package pl.decks.chartjs.radar.options.plugins

import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.legend.LegendAlign
import pl.decks.chartjs.legend.LegendPosition
import pl.decks.chartjs.model.ChartJSOption

data class LegendOptions(
    val display: Boolean = true,
    val position: LegendPosition = LegendPosition.Top,
    val align: LegendAlign = LegendAlign.Center,
    val reverse: Boolean = false,
    val labels: LegendLabelOptions? = null,
    val title: LegendTitleOptions? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.display = display.asDynamic()
        this.position = position.jsValue.asDynamic()
        this.align = align.jsValue.asDynamic()
        this.reverse = reverse.asDynamic()
        if (labels != null) this.labels = labels.toChartJs()
        if (title != null) this.title = title.toChartJs()
    }
}
